import React, { useState } from "react";

import SocialMediaLinks from "../../Components/SocialMediaLinks/SocialMediaLinks";
import LoginCarousel from "./LoginCarousel";

import OtpModal from "./Components/OtpModal";
import { Link } from "react-router-dom";

import PATH from "../../constants/routes";
import LoginHeader from "./Components/LoginHeader";

import "./Login.scss";

export default function Login() {
  const [phoneNumber, setPhoneNumber] = useState();

  const [showOtpModal, setShowOtpModal] = useState<boolean>(false);

  const handlePageSubmit = (e) => {
    e.preventDefault();
    console.log("submit");
    setShowOtpModal(true);
  };

  const handleOtpModalClose = () => {
    setShowOtpModal(false);
  };
  return (
    <div className="login_container">
      <LoginHeader />
      <div className="login_body">
        <div className="login_carousel_container">
          <LoginCarousel />
        </div>

        <div className="login_info_container">
          <div className="login_info_card">
            <h3>Lets get started</h3>
            <p>Enter your email to signin .</p>

            <form onSubmit={handlePageSubmit}>
              <label htmlFor="email">Email</label>
              <input id="email" type="email" />

              <label htmlFor="password">Password</label>
              <input id="password" type="text" />

              {/* <PhoneInput country={"np"} value={phoneNumber} onChange={() => {}} searchPlaceholder={"search for country"} style={{ width: "100%" }} /> */}
              <button type="submit" className="button button_primary">
                Continue
              </button>
            </form>
            <p className="terms_and_condition">
              By Signing up, you agree Terms and condition for the zunun.
            </p>

            <Link to={`/${PATH.SIGNUP}`} className="signup_link">
              Don't have an account? Sign up
            </Link>
          </div>
        </div>
      </div>

      {/* modals here */}
      {/* <OtpModal  showModal={showOtpModal} handleClose={handleOtpModalClose} /> */}
    </div>
  );
}
